module.exports = __webpack_public_path__ + "static/media/excel_logo.171c8d76.png";